import { render, staticRenderFns } from "./ProjectSessionCreationModal.vue?vue&type=template&id=a45e8ac4&scoped=true&"
import script from "./ProjectSessionCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProjectSessionCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSessionCreationModal.vue?vue&type=style&index=0&id=a45e8ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e8ac4",
  null
  
)

export default component.exports